export enum PaymentFields {
	MembershipTerms = 'membershipTerms',
	CCMTerms = 'ccmTerms',
	CabelasMembershipTerms = 'cabelasMembershipTerms',
	CabelasTerms = 'cabelasTerms',
	SigSauerAmmoTerms = 'sigSauerAmmoTerms',
	SigSauerOpticTerms = 'sigSauerOpticTerms',
	SigSauerGiftCard = 'sigSauerGiftCardTerms',
	Beretta250Terms = 'beretta250Terms',
	GiftCardGeneralTerms = 'giftCardGeneralTerms',
	GiftCard75Terms = 'giftCard75Terms',
	BrantleyGilbertTerms = 'brantleyGilbertTerms',
	UseCardOnFile = 'useCardOnFile',
	PewPewTerms = 'pewPewTerms',
	PrimaryArmsOptic = 'primaryArmsOptic'
}
